(() => {
  const requests = new WeakMap();
  document.addEventListener('change', async (event) => {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-crew-option]')) return;
    const root = event.target.closest('[data-crew-product]');
    if (!root) return;
    requests.get(root)?.abort();
    const controller = new AbortController();
    requests.set(root, controller);
    const selection = [...root.querySelectorAll('[data-crew-option]')].map(field => field.value).join(',');
    const url = new URL(location.href);
    url.searchParams.delete('variant');
    url.searchParams.set('option_values', selection);
    const requestUrl = new URL(url);
    requestUrl.searchParams.set('section_id', root.dataset.sectionId);
    const focusId = event.target.id;
    root.setAttribute('aria-busy', 'true');
    root.querySelector('[data-crew-add]').disabled = true;
    try {
      const response = await fetch(requestUrl, { signal: controller.signal });
      if (!response.ok) throw new Error('Product refresh failed');
      const html = await response.text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-crew-product]');
      if (!next) throw new Error('Product section missing');
      if (controller.signal.aborted) return;
      root.replaceWith(next);
      history.replaceState(null, '', url);
      document.getElementById(focusId)?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url);
    }
  });
})();
document.addEventListener('click', (event) => {
  const buddy = event.target.closest('[data-buddy-name]');
  if (buddy) {
    const root = buddy.closest('[data-buddy-explorer]');
    const art = root.querySelector('.buddy-art');
    root.querySelectorAll('[data-buddy-name]').forEach(button => button.setAttribute('aria-pressed', String(button === buddy)));
    art.removeAttribute('srcset');
    art.src = buddy.dataset.buddyArt;
    art.alt = 'PAW POINT CREW — ' + buddy.dataset.buddyName;
    root.querySelector('[data-buddy-title]').textContent = buddy.dataset.buddyName;
    root.querySelector('[data-buddy-species]').textContent = buddy.dataset.buddySpecies;
  }
  const thumbnail = event.target.closest('[data-gallery-src]');
  if (thumbnail) {
    const gallery = thumbnail.closest('[data-product-gallery]');
    const main = gallery.querySelector('.gallery-main');
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = thumbnail.dataset.gallerySrc;
    main.alt = thumbnail.dataset.galleryAlt;
    gallery.querySelectorAll('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
  }
});
